import {useMemo} from "react";
import getProgressData from "../utils/getProgressData";
import VideoPreview from "./VideoPreview";

const VideoTitle = ({video, savedTime}) => {
  const {label, classes, dot} = useMemo(
    () =>
      getProgressData
        ? getProgressData(savedTime, video)
        : {label: "", classes: "", dot: ""},
    [savedTime, video],
  );

  return (
    <div className="px-2 pb-2">
      <span
        className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-[11px] font-bold mb-1.5 border whitespace-nowrap ${classes}`}
      >
        <span className={`w-1.5 h-1.5 rounded-full ${dot}`} />
        {label}
      </span>
      <h3 className="text-[#1a1a1a] font-semibold text-lg md:text-base leading-tight mb-1">
        {video.title}
      </h3>
      <p className="text-[#1a1a1a]/50 text-xs font-medium">
        Category: <span className="text-[#1a1a1a]">{video.category}</span>
      </p>
    </div>
  );
};

const VideoCard = ({video, savedTime, onInteraction, onExpand}) => {
  // YouTube model: a grid card is a dumb thumbnail. Tapping it opens the
  // half-screen player (the modal) -- there is no inline playback and no
  // fullscreen/expand control on the card itself. This keeps the cards cheap
  // to mount/unmount as the virtualized grid recycles them while scrolling
  // (no per-card player, RxJS Subject, keydown listener, or progress timer),
  // and it means a learner can never watch a video without first opening the
  // half-screen player.
  const duration = video?.videoLength || 0;
  const pct =
    duration > 0 ? Math.min(100, Math.max(0, (savedTime / duration) * 100)) : 0;

  const open = () => {
    onInteraction?.();
    onExpand();
  };

  return (
    <div className="bg-white md:bg-[#f8fafc] rounded-3xl p-0 md:p-2 group flex flex-col h-full overflow-hidden">
      <button
        type="button"
        aria-label={`Play ${video.title}`}
        onClick={open}
        className="mb-2 relative bg-black overflow-hidden rounded-[2rem] w-full aspect-video block focus:outline-none focus:ring-2 focus:ring-indigo-300"
      >
        <VideoPreview videoUrl={video.url} />

        {/* Watched-progress bar (non-interactive), like the red line YouTube
            shows on partially-watched thumbnails. Hidden when nothing has
            been watched yet. */}
        {pct > 0 && (
          <span className="absolute bottom-0 left-0 right-0 h-1.5 bg-white/30 z-10">
            <span
              className="block h-full bg-orange-500"
              style={{width: `${pct}%`}}
            />
          </span>
        )}
      </button>

      <VideoTitle {...{video, savedTime}} />
    </div>
  );
};

export default VideoCard;
